export enum Country {
    CZ = 43
}